import {
    NS_BAR_LENGHT_500,
    NS_BAR_LENGHT_750,
    NS_BAR_LENGHT_1000,
    NS_BAR_LENGHT_500_IMAGE,
    NS_BAR_LENGHT_750_IMAGE,
    NS_BAR_LENGHT_1000_IMAGE
} from "./ns-bar-length";

export const OVER_LANDING_BAR_QUANTITY = {
    "66236FB5-4675-4767-86F8-632BFDE26894": {
        // 3 bars
        image: {
            default: "https://assets.rhinorack.com/Images/VehicleImages/Truck-Bed/Generic/OverlandingBars-3bar-01-op.jpg"
        },

    },
    "A6B4D90E-958D-41CE-BC01-7DAECAE521B0": {
        // 2 bars
        image: {
            default: "https://assets.rhinorack.com/Images/VehicleImages/Truck-Bed/Generic/OverlandingBars-2bar-01-op.jpg"
        }
    }
};


export const VORTEX_BAR_QUANTITY = {
    "66236FB5-4675-4767-86F8-632BFDE26894": {
        // 3 bars
        image: {
            default: "https://assets.rhinorack.com/Images/VehicleImages/Truck-Bed/Generic/Vortex-3bar-01-no%20handle-op.jpg"
        }
    },
    "A6B4D90E-958D-41CE-BC01-7DAECAE521B0": {
        // 2 bars
        image: {
            default: "https://assets.rhinorack.com/Images/VehicleImages/Truck-Bed/Generic/Vortex-2bar-01-op-no%20handle.jpg"
        }
    }
};

export const NS_BAR_QUANTITY = {
           "66236FB5-4675-4767-86F8-632BFDE26894": {
               // 3 bars
               image: {
                   default:
                       "https://assets.rhinorack.com/Solution/Jeep-Gladiator-OverlandingBars-3rd-Portal-NS_Bars-01-op.jpg"
               },
               [NS_BAR_LENGHT_500]: NS_BAR_LENGHT_500_IMAGE,
               [NS_BAR_LENGHT_750]: NS_BAR_LENGHT_750_IMAGE,
               [NS_BAR_LENGHT_1000]: NS_BAR_LENGHT_1000_IMAGE
           },
           "A6B4D90E-958D-41CE-BC01-7DAECAE521B0": {
               // 2 bars
               image: {
                   default:
                       "https://assets.rhinorack.com/Images/VehicleImages/Truck-Bed/Generic/OverlandingBars-NS-01-op.jpg"
               },
               [NS_BAR_LENGHT_500]: NS_BAR_LENGHT_500_IMAGE,
               [NS_BAR_LENGHT_750]: NS_BAR_LENGHT_750_IMAGE,
               [NS_BAR_LENGHT_1000]: NS_BAR_LENGHT_1000_IMAGE
           }
       };
